// Stable per-browser id, used for anonymous daily-usage tracking.
const KEY = "vc_device_id";

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `dev_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}
